import { requestHelpers, FormFieldHelpers } from '../../helpers';

const actions = {
    GET_CURRENT_MEMBER: 'GET_CURRENT_MEMBER',
    SET_CURRENT_MEMBER: 'SET_CURRENT_MEMBER',
    GET_MEMBERS: 'GET_MEMBERS',
    SET_MEMBERS: 'SET_MEMBERS',
    CLEAR_MEMBERS: 'CLEAR_MEMBERS',
    SET_SEARCH_INITIAL_VALUES: 'SET_SEARCH_INITIAL_VALUES',
    SET_OTHER_PROFILE: 'SET_OTHER_PROFILE',
    GET_OTHER_PROFILE: 'GET_OTHER_PROFILE',
    SET_OTHER_PICTURE: 'SET_OTHER_PICTURE',
    SET_OTHER_CUSTOM_URL: 'SET_OTHER_CUSTOM_URL',
    SET_OTHER_COUNTRIES: 'SET_OTHER_COUNTRIES',
    SET_OTHER_USER_PERMISSIONS: 'SET_OTHER_USER_PERMISSIONS',
    SET_OTHER_INVESTMENTS_LIST: 'SET_OTHER_INVESTMENTS_LIST',
    SET_OTHER_PROFILE_LOADED: 'SET_OTHER_PROFILE_LOADED',
    DESTROY_OTHER_PROFILE: 'DESTROY_OTHER_PROFILE',
};

function getCurrentMember( memberId ) {
    return ( dispatch ) => {
        dispatch( {
            type: actions.GET_CURRENT_MEMBER,
            memberId,
        } );
        requestHelpers
            .authenticatedGetRequest( `/members/${ memberId }` )
            .then( ( response ) => {
                dispatch( {
                    type: actions.SET_CURRENT_MEMBER,
                    member: response.data,
                } );
            } );
    }
}

function getMembers( options, page ) {
    return ( dispatch ) => {
        dispatch( {
            type: actions.GET_MEMBERS,
            // tagId,
            members: 'Loading',
        } );

        let newOptions;

        if ( !options || options === null ) {
            newOptions = options = {};
        } else {
            newOptions = { ...options };
        }

        // newOptions.tag_id = tagId;

      if (options.country_id) {
        newOptions.country_id = FormFieldHelpers
          .extractValue(options.country_id);
      }

      if (options.region_id) {
        newOptions.region_id = FormFieldHelpers
          .extractValue(options.region_id);
      }

      if (options.expertise_id) {
        newOptions.expertise_id = FormFieldHelpers
          .extractValue(options.expertise_id);
      }

      if (options.industry_id) {
        newOptions.industry_id = FormFieldHelpers
          .extractValue(options.industry_id);
      }


        if ( !page ) {
            newOptions.page = 1;
        } else {
            newOptions.page = page;
        }

        dispatch( {
            type: actions.SET_SEARCH_INITIAL_VALUES,
            options,
        } );

        requestHelpers
            .authenticatedGetRequest( '/profiles', newOptions )
            .then( ( response ) => {
                response.newData = response.data.map( member => {
                    const picturePath = new Request( `https://s3.intouchnetworks.com/getImage.php?id=${ member.id }` );
                    return fetch( picturePath )
                        .then( ( response ) => response.text() )
                        .then( ( url ) => {
                            member = Object.assign( member, { picture: url } );
                            return member;
                        } );
                } );
                const fetchPicturesProm = Promise.all( response.newData );
                return Promise.all( [ response, fetchPicturesProm ] );
            } )
            .then( ( [ response, newData ] ) => {
                return dispatch( {
                    type: actions.SET_MEMBERS,
                    members: newData,
                    pagination: response.meta,
                    options,
                } );
            } )
    }
}

function getOtherProfile( personId ) {
    return ( dispatch ) => {

        // dispatch( {
        //     type: actions.GET_OTHER_PROFILE,
        //     isFetching: true,
        //     isError: false,
        //     guestMode: true,
        // } );

        requestHelpers
            .authenticatedGetRequest( `/profiles/${ personId }` )
            .then( ( response ) => {
                dispatch( {
                    type: actions.SET_OTHER_PROFILE,
                    guestMode: true,
                    otherProfile: response.data,
                } );
                return personId;
            } )
            .then( ( personId ) => {


                const  picturePath = new Request (`https://s3.intouchnetworks.com/getImage.php?id=${ personId }`);

                fetch( picturePath )
                    .then( ( response ) => response.text() )
                    .then( ( url ) => {

                        const isDefault = url.indexOf("default.png") > -1;

                        dispatch( {
                            type: actions.SET_OTHER_PICTURE,
                            personId,
                            url,
                            isDefault,
                        } );

                    } );

                return personId;

            } )
            .then( ( personId ) => {
                requestHelpers
                    .authenticatedGetRequest( `/people/${ personId }/custom-url` )
                    .then( ( response ) => {
                      const newData = response.data[0];

                        if( typeof newData.custom_url !== 'undefined' ) {
                            dispatch( {
                                type: actions.SET_OTHER_CUSTOM_URL,
                                1: `https://www.nonexecutivedirectors.com/profiles/${newData.custom_url}/${newData.person_id}`,
                                2: `https://www.theconsultanthub.com/profiles/${newData.custom_url}/${newData.person_id}`,
                                3: `https://www.financedirectornetwork.com/profiles/${newData.custom_url}/${newData.person_id}`,
                                4: `https://womendirectors.com/profiles/${newData.custom_url}/${newData.person_id}`,
                                5: `https://www.investordirector.com/profiles${newData.custom_url}/${newData.person_id}`,
                            } );
                        } else {
                            dispatch( {
                                type: actions.SET_OTHER_CUSTOM_URL,
                                1: `https://www.nonexecutivedirectors.com/profiles/${newData.url}/${newData.person_id}`,
                                2: `https://www.theconsultanthub.com/profiles/${newData.url}/${newData.person_id}`,
                                3: `https://www.financedirectornetwork.com/profiles/${newData.url}/${newData.person_id}`,
                                4: `https://womendirectors.com/profiles/${newData.url}/${newData.person_id}`,
                                5: `https://www.investordirector.com/profiles/${newData.url}/${newData.person_id}`,
                            } );
                        }

                    } )
            } )
            .then( () => {

                requestHelpers.authenticatedGetRequest('/common/locations/countries')
                    .then( (response) => {
                        dispatch( {
                            type: actions.SET_OTHER_COUNTRIES,
                            countries: response.data,
                        } );
                    });

            } )
            .then( () => {

                const permissions = JSON
                    .parse(localStorage
                        .getItem("permissions"))
                    .find( item => ( item.type === 1 ) );
                dispatch( {
                    type: actions.SET_OTHER_USER_PERMISSIONS,
                    personId,
                    // hasExecute: permissions ? permissions.execute : false,
                } )

            } )
            .then( () => {

                requestHelpers
                    .authenticatedGetRequest( `/common/investments` )
                    .then( (response) => {
                        dispatch( {
                            type: actions.SET_OTHER_INVESTMENTS_LIST,
                            ranges: response.data,
                        } )
                    })
            } )
            .then( () => {
                dispatch( {
                    type: actions.SET_OTHER_PROFILE_LOADED,
                    isFetching: false,
                    isError: false,
                    personId: parseInt(personId, 10),
                } )
            } );
    }

}

function destroyOtherProfile() {
    return (dispatch) => {
        dispatch({
            type: actions.DESTROY_OTHER_PROFILE,
            isFetching: false,
            isError: false,
        })
    }
}

function unmountMembers() {

    return (dispatch) => {
        dispatch({
            type: actions.CLEAR_MEMBERS,
        });
    }

}

module.exports = {
    actions,
    getCurrentMember,
    getMembers,
    getOtherProfile,
    destroyOtherProfile,
    unmountMembers,
};



// WEBPACK FOOTER //
// src/client/actions/members/members.js